import { CLType } from './CLType';
import { DeployContractPackageResult } from './Deploy';
import { AccountResult } from './Account';

export enum ContractTypes {
  Cep18 = 2,
  CustomCep18 = 3,
  CEP47Nft = 4,
  CustomCEP47Nft = 5,
  DeFi = 6,
  CEP78Nft = 7,
  CustomCEP78Nft = 8,
  CEP95Nft = 10,
}

export enum ContractTypeId {
  System = 1,
  Cep18 = 2,
  CustomCep18 = 3,
  CEP47Nft = 4,
  CustomCEP47Nft = 5,
  DeFi = 6,
  CEP78Nft = 7,
  CustomCEP78Nft = 8,
  NFTMarketplace = 9,
  CEP95Nft = 10,
}

export interface ContractTypeData {
  id: number;
  name: string;
}

export interface ContractPackageGroupV1 {
  group: string;
  keys: string[];
}

export interface ContractPackageGroupV2 {
  group_name: string;
  group_users: string[];
}

export interface ContractPackageVersionRawResult {
  disabled: boolean;
  protocol_version_major: number;
  contract_version: number;
  contract_hash: string;
}

export interface ContractPackageDisabledVersion {
  protocol_version_major: number;
  contract_version: number;
}

export interface ContractPackageRawResult {
  access_key: string;
  versions: ContractPackageVersionRawResult[];
  disabled_versions: ContractPackageDisabledVersion[];
  groups: ContractPackageGroupV1[] | ContractPackageGroupV2[];
  lock_status: string;
}

export interface ContractPackageVersion {
  block_height: number;
  contract_hash: string;
  contract_package: DeployContractPackageResult;
  contract_package_hash: string;
  contract_type_id: number;
  major_protocol_version: number;
  contract_version: number;
  deploy_hash: string;
  is_disabled: boolean;
  timestamp: string;
}

export interface ContractNamedKeys {
  key: string;
  name: string;
}

export type ContractParameter = {
  cl_type: CLType;
  name: string;
};

export type ContractEntryPointAccess = 'Public' | Record<string, any>;

export interface ContractEntryPointV1 {
  access: ContractEntryPointAccess;
  args: ContractParameter[];
  entry_point_type: string;
  name: string;
  ret: string | CLType;
}

export interface ContractEntryPointV2 {
  name: string;
  entry_point: ContractEntryPointV1;
}

export interface ContractRawResult {
  contract_package_hash: string;
  contract_wasm_hash: string;
  protocol_version: string;
  entry_points: ContractEntryPointV1[] | ContractEntryPointV2[];
  named_keys: ContractNamedKeys[];
  deploys: any[];
}

export interface ContractDataRawResult {
  ContractPackage: ContractPackageRawResult | null;
  Contract: ContractRawResult | null;
  Account: AccountResult | null;
}

export type ContractResult = {
  block_height: number;
  contract_hash: string;
  contract_package_hash: string;
  contract_type_id: number;
  contract_version: number;
  deploy_hash: string;
  from_purse_public_key: string;
  is_disabled: boolean;
  timestamp: string;
  contract_package?: DeployContractPackageResult;
};

export const isContractTypeCep18 = (contractPackage): boolean =>
  contractPackage?.latest_version_contract_type_id ===
    ContractTypeId.CustomCep18 ||
  contractPackage?.latest_version_contract_type_id === ContractTypeId.Cep18;

export function ContractData(obj: any): ContractDataRawResult {
  return obj;
}

export const filterNamedKeysForContractPurses = (
  namedKeys: ContractNamedKeys[] | undefined
): ContractNamedKeys[] => {
  if (!namedKeys) {
    return [];
  }

  return namedKeys.filter((key) => {
    if (key.name.indexOf('purse') > -1 && !key.name.match(/balance/)) {
      return key;
    }

    return false;
  });
};

export enum LockedStatus {
  'Locked' = 'Locked',
  'Unlocked' = 'Unlocked',
}
